export { default } from './Popover';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Popover/index.js
// module id = 198
// module chunks = 121